import React from "react";
import Lottie from "lottie-react";
import loaderAnimation from "./MainLoader.json";

const MainLoader = () => {
  return (
    <div style={styles.container}>
      <Lottie   
        animationData={loaderAnimation} 
        loop={true} 
        style={{ width: 150, height: 150 }}
      />
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
};

export default MainLoader;